export default {
  'team.title': '团队',
  'team.role': '角色',
  'team.member': '员工',
  'team.addRole': '新增角色',
  'team.saveRole': '保存角色',
  'team.removeStaff': '删除员工',
  'team.addStaff': '新增员工',
  'team.addDepartment': '新增部门',
  'team.roles.numberOfMembers': '员工数量',
  'team.deleteRole.promptTitle': '角色删除提示',
  'team.deleteRole.promptContent': '确认要删除此角色吗？',
  'team.deleteRole.success': '删除角色成功',
  'team.deleteMembers.success': '删除员工成功',
  'team.deleteMember.promptTitle': '删除员工提示',
  'team.deleteMember.promptContent': '确定要删除选中的员工吗？',
  'team.deleteSingleMember.promptContent': '确定要删除此员工吗？',
  'team.activateMember.promptTitle': '激活员工提示',
  'team.activateMember.promptContent': '确定要激活此员工吗？',
  'team.deactivateMember.promptTitle': '冻结员工提示',
  'team.deactivateMember.promptContent': '确定要冻结此员工吗？',
  'team.owner.deletionDeclined': '餐厅老板不能被删除',
  'team.owner.deactivateDeclined': '餐厅老板不能被冻结',
  'team.addMember.success': '新增员工成功',
  'team.editMember.success': '更新员工成功',
  'team.cannotCreateRoleBeforeActivate': '餐厅激活前不能创建角色',
  'team.cannotCreateEmployeeBeforeActivate': '餐厅激活前不能创建员工',
};
